/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Applications_TitleInputs */

const en_candidate_applications_title = /** @type {(inputs: Candidate_Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications`)
};

const de_candidate_applications_title = /** @type {(inputs: Candidate_Applications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen`)
};

/**
* | output |
* | --- |
* | "Applications" |
*
* @param {Candidate_Applications_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_applications_title = /** @type {((inputs?: Candidate_Applications_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Applications_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_applications_title(inputs)
	return en_candidate_applications_title(inputs)
});